import React, { ReactNode } from 'react';

import { PRODUCT_LINKS } from 'consts/products';
import { EcomProductCTAButton, ProductCardImage } from './components';
import {
  Description,
  Name,
  ProductCardContainer,
  ProductCardDetails,
} from './ProductCard.style';

export interface ProductCardProps {
  linkType: valueof<typeof PRODUCT_LINKS>;
  href: string;
  name: string;
  tag?: 'Rx';
  description: string;
  price: string;
  image: ReactNode;
  imageTag?: string;
  hideButton?: boolean;
}

export const ProductCard = ({
  content,
  productCardCTAText,
}: {
  content: ProductCardProps;
  productCardCTAText?: string;
}) => {
  const { name, tag, description, linkType, hideButton } = content;

  const isEcomProduct = linkType === PRODUCT_LINKS.eCommerce;
  const ctaText = productCardCTAText || 'Shop now';

  return (
    <ProductCardContainer isEcomProduct={isEcomProduct}>
      <ProductCardImage content={content} />
      <ProductCardDetails isEcomProduct={isEcomProduct}>
        <Name>
          {name}
          {tag && <sup>{tag}</sup>}
        </Name>
        <Description>{description}</Description>
        {/* <Price>{price}</Price> */}
      </ProductCardDetails>
      {isEcomProduct && !hideButton && (
        <EcomProductCTAButton product={content}>{ctaText}</EcomProductCTAButton>
      )}
    </ProductCardContainer>
  );
};
